<div class="file-status-chip" [style.background-color]="color" [style.color]="textColor">
    <img *ngIf="icon" [src]="getIconPath(icon)" alt="status" />
    {{ text }}
    <ng-container *ngIf="text !== 'Done' && rowTable.chunks && rowTable.completed_chunks"
        >({{ ((rowTable.completed_chunks / rowTable.chunks) * 100).toFixed(0) }}%)</ng-container
    >
</div>
